// import Drawer from '@/components/Drawer'
import SvgLib from '@/components/SvgLib'
import LightSources from '@/components/LightSources'
import OutlineButton from '@/components/OutlineButton'
import axios from 'axios'
import { bus } from '@/consts'
import { TimelineMax, TweenMax, Power3 } from 'gsap'
import * as Cookies from 'js-cookie'
import ClipboardJS from 'clipboard'

export default {
  name: 'Ticket',
  template: '#ticket-template',
  components: {
    SvgLib,
    OutlineButton,
    LightSources
  },
  data () {
    return {
      promoName: 'clash-2019',
      encSiteUrl: window.clash2018.encSiteUrl,
      encTwitterShareMsg: '',
      regionMap: {
        pbe: 'pbe1',
        na: 'na1',
        br: 'br1',
        eun: 'eun1',
        euw: 'euw1',
        tr: 'tr1',
        id: 'id1',
        jp: 'jp1',
        lan: 'la1',
        las: 'la2',
        eune: 'eun1',
        oce: 'oc1'
      },
      introComplete: false,
      modalActive: false,
      ticketIntroTl: new TimelineMax({paused: true}),
      clipboard: new ClipboardJS('.share-btn--link')
    }
  },
  computed: {
    summonerName () {
      let c = Cookies.get()
      for (const k in c) {
        if (k.indexOf('PVPNET_ACCT') >= 0) return Cookies.get(k).replace(/\+/g, ' ')
      }
      return window.clash2018.summoner
    },
    teamTag () {
      return this.$store.state.teamTag !== '' ? this.$store.state.teamTag : window.clash2018.teamTag
    },
    teamName () {
      return this.$store.state.teamName !== '' ? this.$store.state.teamName : window.clash2018.teamName
    },
    apiRegion () {
      for (const r in this.regionMap) {
        if (r === window.clash2018.region) return this.regionMap[r]
      }
      return window.clash2018.region
    },
    apiURL () {
      return `https://${this.apiRegion}.api.riotgames.com/clash-partner/v1/promo/${this.promoName}/players`
    },
    returnUrl () {
      return 'https://{region}.leagueoflegends.com/{lang}/featured/clash#/ticket'
    },
    clipboardText () {
      return window.clash2018.siteUrl
    },
    showClipboardLink () {
      return ClipboardJS.isSupported()
    }
  },
  watch: {
    '$route' (to) {
      this.modalActive = false
      if (to.name === 'ticketclaim') {
        this.handleFinalScreen()
      }
      if (to.name === 'ticket') {
        this.ticketIntro()
      }
    }
  },
  methods: {
    handleClaimErrorGeneric () {
      this.$store.commit('setTicketRedemptionStatus', 0)
      this.modalActive = true
    },
    handleClaimErrorLogin () {
      let statusCode = this.isIE11 ? 4 : 1
      this.$store.commit('setTicketRedemptionStatus', statusCode)
      this.modalActive = true
    },
    handleClaimErrorGranted () {
      this.$store.commit('setTicketRedemptionStatus', 2)
      this.$router.push('/ticket/claim')
    },
    handleClaimSuccess () {
      this.$store.commit('setTicketRedemptionStatus', 3)
      this.trackEvent('Ticket Payout', 'Ticket Redemption Successful')
      this.$router.push('/ticket/claim')
    },
    handleLogin () {
      window.RiotBar.account.login(this.returnUrl)
    },
    handleFinalScreen () {
      if ((this.$store.state.ticketRedemptionStatus === 2 || this.$store.state.ticketRedemptionStatus === 3)) {
        this.modalActive = true
      }
    },
    claimTicket () {
      this.trackEvent('Your Free Ticket', 'Your Free Ticket: Button: Claim Your Ticket')

      axios.create({
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).post(this.apiURL)
        .then(response => {
          switch (response.status) {
            case 200:
            case 201:
            case 202:
            case 203:
            case 204:
            case 205:
            case 206:
            case 207:
            case 208:
            case 226:
              // Ticket successfully redeemed!
              this.handleClaimSuccess()
              break
          }
        })
        .catch(error => {
          if (error.response) {
            switch (error.response.status) {
              case 400:
                // Ticket already redeemed!
                this.handleClaimErrorGranted()
                break
              case 401:
              case 403:
                // Please log in first
                this.handleClaimErrorLogin()
                break
              case 500:
                // Error granting ticket
                this.handleClaimErrorGeneric()
                break
              case 503:
                // API server is offline
                this.handleClaimErrorGeneric()
                break
            }
          } else if (error.request) {
            // 401 - Unauthorized Access
            this.handleClaimErrorGeneric()
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message)
            this.handleClaimErrorGeneric()
          }
        })
    },
    showLinkCopiedMsg () {
      let xValStart = this.$store.state.isMobile ? '0%' : '100%'
      let xValEnd = this.$store.state.isMobile ? '0%' : '95%'
      let yVal = this.$store.state.isMobile ? '110%' : '-50%'
      TweenMax.to(this.$refs.linkToolTip, 0.2, {opacity: 1,
        x: xValStart,
        y: yVal,
        ease: Power3.easeIn,
        onComplete: () => {
          TweenMax.to(this.$refs.linkToolTip, 0.2, {opacity: 0, x: xValEnd, y: yVal, ease: Power3.easeIn}).delay(2)
        }
      })
    },
    setTwitterShareMsg () {
      if (this.encTwitterShareMsg === '') {
        let twitterShareMsg = this.$refs.twittershare.dataset.shareMsg
        this.encTwitterShareMsg = encodeURIComponent(twitterShareMsg)
      }
    },
    openWindow (url, network) {
      if (this.encTwitterShareMsg === '') {
        this.setTwitterShareMsg()
      }
      window.open(url, 'Share to ' + network, 'height=350,width=600')
    },
    ticketIntro () {
      this.ticketIntroTl.fromTo(this.$refs.ticketIntroBg, 1.5, {scale: 1.08}, {scale: 1})
      this.ticketIntroTl.addCallback(() => { this.introComplete = true }, 0.5)
      this.ticketIntroTl.restart()
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$route.name === 'ticket') {
        this.ticketIntro()
        bus.$emit('closeOverlay')
      } else if (this.$route.name === 'ticketclaim') {
        this.setTwitterShareMsg()
        this.handleFinalScreen()
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    if (window.clash2018.region === 'zh' && to.name === 'ticket') {
      next('/ticket/claim')
    } else {
      next()
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (window.clash2018.region === 'zh' && to.name === 'ticket') {
      next('/ticket/claim')
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Ticket.js